const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecycleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "24px",
    height: "24px",
    viewBox: "0 0 0.72 0.72",
    id: "recycle",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M0.651 0.57a0.062 0.062 0 0 1 -0.053 0.03H0.48a0.03 0.03 0 0 1 0 -0.06l0.118 0.002c0.002 -0.002 0 -0.004 0 -0.004l-0.071 -0.123 -0.004 0.013a0.03 0.03 0 1 1 -0.056 -0.02l0.026 -0.074a0.03 0.03 0 0 1 0.036 -0.019l0.082 0.022a0.03 0.03 0 1 1 -0.016 0.058l-0.012 -0.003 0.068 0.117a0.063 0.063 0 0 1 0.001 0.062M0.467 0.246A0.03 0.03 0 0 0 0.48 0.205l-0.065 -0.113a0.06 0.06 0 0 0 -0.053 -0.03 0.063 0.063 0 0 0 -0.054 0.03L0.24 0.208l-0.003 -0.012a0.03 0.03 0 0 0 -0.037 -0.021 0.03 0.03 0 0 0 -0.021 0.037l0.022 0.082a0.03 0.03 0 0 0 0.03 0.022 0.018 0.018 0 0 0 0.005 0L0.312 0.3a0.03 0.03 0 1 0 -0.011 -0.06l-0.013 0.002L0.36 0.122s0 -0.002 0.004 0l0.064 0.114a0.03 0.03 0 0 0 0.04 0.01m-0.166 0.244a0.03 0.03 0 0 0 -0.046 0.039l0.009 0.01H0.123s-0.003 0 -0.003 -0.003l0.066 -0.112a0.03 0.03 0 0 0 -0.01 -0.041 0.03 0.03 0 0 0 -0.041 0.01l-0.066 0.112a0.06 0.06 0 0 0 0 0.061A0.062 0.062 0 0 0 0.123 0.6h0.135l-0.009 0.009a0.03 0.03 0 0 0 0 0.043 0.03 0.03 0 0 0 0.043 0l0.06 -0.06a0.03 0.03 0 0 0 0 -0.041Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleIcon);
export default __webpack_public_path__ + "static/media/recycle_icon.c221315fe8dce43d880a3588d1600c27.svg";
export { ForwardRef as ReactComponent };